import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const TABS = [
  { to: "/", label: "Room Designer" },
  { to: "/led-configurator", label: "LED Configurator" },
];

export default function ModeSwitcher() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      style={{
        position: "absolute", left: "50%", bottom: 0, transform: "translate(-50%, 50%)",
        display: "flex", background: "var(--app-surface)", border: "1px solid var(--app-border)",
        borderRadius: 999, padding: 3, boxShadow: "0 4px 14px rgba(15,23,42,0.10)", zIndex: 200,
      }}
    >
      {TABS.map((tab) => {
        const active = location.pathname === tab.to;
        return (
          <button
            key={tab.to}
            onClick={() => !active && navigate(tab.to)}
            style={{
              padding: "7px 18px", borderRadius: 999, border: "none", cursor: active ? "default" : "pointer",
              fontSize: 12.5, fontWeight: 700, whiteSpace: "nowrap",
              background: active ? "var(--app-accent)" : "transparent",
              color: active ? "var(--app-accent-text)" : "var(--app-text-muted)",
              transition: "background 0.15s, color 0.15s",
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
